<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="md:translate-y-3 -translate-y-3 opacity-0"
    enter-to-class="opacity-500 translate-200"
    leave-active-class="transition duration-200 ease-in delay-100"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="md:translate-y-3 -translate-y-3 opacity-0"
  >
    <div
      v-if="show"
      class="fixed inset-0 z-50 w-full h-full"
    >
      <div
        class="opacity-90 bg-primary-900 absolute inset-0 w-full h-full"
        @click="$emit('close')"
      />
      <v-explanation>
        <template #header>
          <div class="top-6 right-6 absolute text-right">
            <span
              class="text-3xl cursor-pointer"
              @click="$emit('close')"
            >
              <i class="mdi mdi-close" />
            </span>
          </div>
          <h3 class="mb-3 leading-tight">
            Your annual carbon footprint :
          </h3>
          <div class="px-5 py-2 border border-gray-300 rounded-md">
            <b class="text-xl text-gray-900">{{ $laravel.user.carbon_footprint }} tons of CO2</b>
          </div>
        </template>
        <template #action>
          <slot name="action" />
        </template>
      </v-explanation>
    </div>
  </transition>
</template>
<script>
import explanation from "./explanation.vue";
export default {
  components: {
    "v-explanation": explanation
  },
  props: {
    show: {
      required: true,
      type: Boolean
    }
  },
  emits: ["close"]
};
</script>
